import { render } from "./NewSeparateLectionPreviewBig.vue?vue&type=template&id=73ac6e12&scoped=true"
import script from "./NewSeparateLectionPreviewBig.vue?vue&type=script&lang=js"
export * from "./NewSeparateLectionPreviewBig.vue?vue&type=script&lang=js"

import "./NewSeparateLectionPreviewBig.vue?vue&type=style&index=0&id=73ac6e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ac6e12"]])

export default __exports__